import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Title, Box } from '@deseretbook/react-ui'

import { Lesson } from '.'

/**
 * Container for Lessons list
 *
 * @param {array} lessons - list of playable lessons from course
 *
 * @returns {function} React Component
 */
export const Lessons = ({ lessons = [], handleLessonChange, activeLesson, isDisabled }) => {
  return (
    <Grid
      columns={Grid.fr(1)}
      rows={Grid.repeat(Grid.autoFill, Grid.minMax(5, Grid.fr(1)))}
      alignItems="center"
      justifyContent="start"
    >
      <Box paddingHorizontal={1} paddingBottom={1}>
        <Title title="Lesson plan overview" size={2} />
      </Box>
      {lessons.map((lesson, index) => {
        const position = index + 1

        return (
          <Lesson
            {...lesson}
            position={position}
            isActive={activeLesson && activeLesson.mediaid === lesson.mediaid}
            updateActiveLesson={() => {
              // TODO: Make the signup model open if a user that is not subscribed attempts to click
              if (!isDisabled) {
                handleLessonChange(lesson)
              }
            }}
          />
        )
      })}
    </Grid>
  )
}

Lessons.propTypes = {
  lessons: PropTypes.arrayOf(PropTypes.object),
  handleLessonChange: PropTypes.func,
  activeLesson: PropTypes.shape({
    mediaid: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
}
